// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3j8eE","buttons_container":"style_buttons_container__2Y01x","button":"style_button__WlagC","button__no":"style_button__no__3geAL"};